const SITE_NAME = "Kissariti";

/** French site blurb for SEO and link previews */
export const SITE_SEO_DESCRIPTION =
  "Votre Kissaria en ligne. Le souk féminin nouvelle génération. Pyjamas, lingeries, accessoires.";

export const SITE_SEO = {
  siteName: SITE_NAME,
  titleDefault: `${SITE_NAME} — Votre Kissaria en ligne`,
  description: SITE_SEO_DESCRIPTION,
} as const;

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  if (typeof document === "undefined") return;
  let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function absoluteUrl(pathOrUrl: string): string {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://")) {
    return pathOrUrl;
  }
  const origin =
    typeof window !== "undefined" ? window.location.origin : "https://www.kissariti.ma";
  const path = pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;
  return `${origin}${path}`;
}

export function applyDefaultSiteSeo() {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  const url = window.location.href.split("#")[0];
  const ogImage = absoluteUrl("/logo.png");
  document.title = SITE_SEO.titleDefault;
  upsertMeta("name", "description", SITE_SEO.description);
  upsertMeta("property", "og:site_name", SITE_SEO.siteName);
  upsertMeta("property", "og:title", SITE_SEO.titleDefault);
  upsertMeta("property", "og:description", SITE_SEO.description);
  upsertMeta("property", "og:type", "website");
  upsertMeta("property", "og:url", url);
  upsertMeta("property", "og:image", ogImage);
  upsertMeta("name", "twitter:card", "summary_large_image");
  upsertMeta("name", "twitter:title", SITE_SEO.titleDefault);
  upsertMeta("name", "twitter:description", SITE_SEO.description);
  upsertMeta("name", "twitter:image", ogImage);
}

export function applyProductPageSeo(opts: {
  productName: string;
  productDescriptionPlain: string;
  productId: string | number;
  imageUrl?: string | null;
}) {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  const { productName, productDescriptionPlain, productId, imageUrl } = opts;
  const path = `/product/?id=${encodeURIComponent(String(productId))}`;
  const canonicalUrl = `${window.location.origin}${path}`;
  const title = `${productName} | ${SITE_SEO.siteName}`;
  const snippet = productDescriptionPlain
    ? `${productDescriptionPlain.slice(0, 120)}${productDescriptionPlain.length > 120 ? "…" : ""}`
    : SITE_SEO.description;
  const metaDesc = [snippet, SITE_SEO.description].join(" — ").slice(0, 160);
  const ogImg = imageUrl ? absoluteUrl(imageUrl) : absoluteUrl("/logo.png");

  document.title = title;
  upsertMeta("name", "description", metaDesc);
  upsertMeta("property", "og:site_name", SITE_SEO.siteName);
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", metaDesc.slice(0, 200));
  upsertMeta("property", "og:type", "website");
  upsertMeta("property", "og:url", canonicalUrl);
  upsertMeta("property", "og:image", ogImg);
  upsertMeta("name", "twitter:card", "summary_large_image");
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", metaDesc.slice(0, 200));
  upsertMeta("name", "twitter:image", ogImg);
}
